<template>
  <div v-if="!articleFeatureIcons.length" class="py-4">
    {{ $t('pdp.product_details_no_info') }}
  </div>
  <div
    v-else
    class="flex items-center pt-3 text-sm font-normal leading-5 md:text-lg md:leading-6"
  >
    <NuxtLazyHydrate>
      <ProductFunctionIcons :symbols="articleFeatureIcons" />
    </NuxtLazyHydrate>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { Product } from '@scayle/storefront-nuxt'
import { computed } from 'vue'

const props = defineProps({
  product: {
    type: Object as PropType<Product | null>,
    default: () => null,
  },
})

const getPathWithoutExtension = (val: string) => {
  const arr = val.split('.')
  arr.pop()
  return arr.join('')
}

const articleFeatureIcons = computed(() => {
  const values = props.product?.attributes?.articleFeatureIcon?.values
  if (!values) {
    return []
  }
  if (Array.isArray(values)) {
    return values.map((i) => getPathWithoutExtension(i.label))
  }
  return [getPathWithoutExtension(values.label)]
})
</script>
